import { type FC } from "react";
import { Checkbox } from "antd";

import { AppStrings } from "../../../../utils/constants/AppStrings";
import {
  FINANCIAL_METRIC_IDS,
  PERFORMANCE_METRIC_IDS,
  SHAREABLE_COLUMN_LABELS,
  type ShareableColumnId,
} from "../../NewAffiliate/AffiliatePamAccount/affiliatePamAccountData";

import styles from "./PortalVisibilityToggles.module.css";

export type PortalVisibilityTogglesProps = {
  value: ReadonlyArray<ShareableColumnId>;
  onToggle: (id: ShareableColumnId) => void;
  idPrefix: string;
};

// UI curation only — the BE portal endpoints already strip financial fields
// on RESTRICTED access mode, so toggling FINANCIAL off is not a security gate.
const PortalVisibilityToggles: FC<PortalVisibilityTogglesProps> = ({
  value,
  onToggle,
  idPrefix,
}) => {
  const renderSection = (
    ids: ReadonlyArray<ShareableColumnId>,
    sectionTitle: string,
    sectionKey: string,
  ) => (
    <section className={styles.section} key={sectionKey}>
      <h5 className={styles.sectionTitle}>{sectionTitle}</h5>
      <ul
        className={styles.list}
        data-testid={`${idPrefix}-${sectionKey}-list`}
      >
        {ids.map((id) => {
          const checked = value.includes(id);
          return (
            <li key={id} className={styles.item}>
              <Checkbox
                checked={checked}
                onChange={() => onToggle(id)}
                data-testid={`${idPrefix}-column-${id}`}
              >
                <span className={styles.label}>
                  {SHAREABLE_COLUMN_LABELS[id]}
                </span>
              </Checkbox>
            </li>
          );
        })}
      </ul>
    </section>
  );

  return (
    <aside className={styles.column} data-testid={`${idPrefix}-toggles`}>
      <h4 className={styles.title}>{AppStrings.SELECT_CHART_DATA_TO_SHARE}</h4>
      {renderSection(
        PERFORMANCE_METRIC_IDS,
        AppStrings.PORTAL_VIEW_SECTION_PERFORMANCE,
        "performance",
      )}
      {renderSection(
        FINANCIAL_METRIC_IDS,
        AppStrings.PORTAL_VIEW_SECTION_FINANCIAL,
        "financial",
      )}
    </aside>
  );
};

export default PortalVisibilityToggles;
